//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Tooling.js";
import "../no/Builder.js";
import "../no/SelectPoint.js";
import "../no/SelectNXObjectList.js";
import "../no/SelectObject.js";
import "../no/SelectObjectList.js";
let d=[[[1,"CompSelect",0,"SelectPoint",0],[1,"ConceptObjects",0,"SelectNXObjectList",0],[0,"Rename",1,0]],[[["partNames","sketchNames"],"SetSelectedRecords",{},2,0],[[],"GetStandardPartBatchData",{R_:{batchData:"Tooling.StandardPartBatchData"}},0,0],[["batchData"],"SetStandardPartBatchData",{},1,0],[["conceptObject"],"FindMatchedLibraryOfConceptObject",{R_:{libraryData:"Tooling.StandardPartData"}},1,0],[["conceptObject","assemblyName","assemblyPartNumber","assemblyItemType","childrenNames"],"SaveNameChangesToConceptObject",{},5,0],[["conceptObject","instanceObjects"],"SaveCoolingConceptObjectHandles",{},2,0]],[]];
SPLM.Tooling.MoldProcessBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Tooling.MoldProcessBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;